import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, Phone, ArrowUpRight } from 'lucide-react';
import { COMPANY, CATEGORIES } from '../../mock';
import { categoryPath } from '../../api';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';

const NAV = [
  { label: 'Acasă', to: '/' },
  ...CATEGORIES.map((c) => ({ label: c.title, catKey: c.key })),
  { label: 'Proiecte', to: '/proiecte' },
];

export default function Header({ onQuote }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (to) => {
    setOpen(false);
    if (to.startsWith('/#')) {
      const id = to.slice(2);
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 120);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(to);
    }
  };

  const quote = () => {
    setOpen(false);
    if (onQuote) onQuote();
    else handleNav('/#contact');
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-200">
      <div className="egea-container flex items-center justify-between h-[68px]">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="header-logo">
          <div className="h-9 w-9 bg-[#f5a524] flex items-center justify-center">
            <span className="font-display font-black text-slate-900 text-lg leading-none">E</span>
          </div>
          <div className="leading-none">
            <div className="font-display font-bold text-[17px] tracking-tight text-slate-900">
              {COMPANY.name}
              <span className="text-[#f5a524]">.</span>
              <span className="text-slate-400 font-medium">{COMPANY.brandLine}</span>
            </div>
            <div className="text-[10px] tracking-[0.2em] text-slate-400 uppercase mt-0.5">{COMPANY.since}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <button
              key={n.label}
              onClick={() => handleNav(n.catKey ? categoryPath(n.catKey) : n.to)}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
              className="text-[14px] text-slate-600 hover:text-slate-900 transition-colors font-medium"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={COMPANY.phoneHref} className="flex items-center gap-2 text-[14px] text-slate-700 hover:text-slate-900 transition-colors font-medium">
            <Phone size={15} className="text-[#f5a524]" />
            {COMPANY.phone}
          </a>
          <button onClick={quote} data-testid="header-quote-btn" className="btn-accent px-5 py-2.5 text-[13px] uppercase tracking-wide flex items-center gap-1.5">
            Cere ofertă <ArrowUpRight size={16} />
          </button>
        </div>

        <div className="lg:hidden">
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="p-2 text-slate-900" aria-label="Meniu" data-testid="mobile-menu-btn">
                <Menu size={24} />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-white border-l border-slate-200 text-slate-900 w-[300px]">
              <div className="flex flex-col gap-1 mt-10">
                {NAV.map((n) => (
                  <button
                    key={n.label}
                    onClick={() => handleNav(n.catKey ? categoryPath(n.catKey) : n.to)}
                    data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-left text-[16px] py-3 px-2 border-b border-slate-100 text-slate-700 hover:text-[#f5a524] transition-colors"
                  >
                    {n.label}
                  </button>
                ))}
                <button onClick={() => handleNav('/#contact')} className="text-left text-[16px] py-3 px-2 border-b border-slate-100 text-slate-700 hover:text-[#f5a524] transition-colors">
                  Contact
                </button>
                <a href={COMPANY.phoneHref} className="flex items-center gap-2 py-4 text-slate-700">
                  <Phone size={16} className="text-[#f5a524]" /> {COMPANY.phone}
                </a>
                <button onClick={quote} className="btn-accent px-5 py-3 text-[15px] uppercase tracking-wide mt-2">
                  Cere ofertă
                </button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
